import { AnimatePresence } from "framer-motion";
import Home from "./pages/Home";
import PageContainer from "./pages/PageContainer";
import { Route, Routes, useLocation } from "react-router-dom";
import { ReactLenis } from '@studio-freight/react-lenis'
import AboutPage from "./pages/AboutPage";
import SustainabilityPage from "./pages/SustainabilityPage";
import Uretim from "./pages/Uretim";
import Rand from "./pages/Rand";
import SocialResponsibility from "./pages/SocialResponsibility";
import Products from "./pages/Products";
import ProductDetail from "./components/product/ProductDetail";
import Contact from "./pages/Contact";
import { useEffect } from "react";

import BrandsDetail from "./components/brands/BrandDetail";


function App() {

  const location = useLocation();

  useEffect(() => {
 
    window.scrollTo(0, 0);
}, [location.pathname]);


  return (

    <ReactLenis root>
    <div className="App relative ">
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<PageContainer />} >
            <Route path="/" element={<Home />} />
            <Route path="/hakkimizda" element={<AboutPage />} />
            <Route path="/surdurulebilirlik" element={<SustainabilityPage />} />
            <Route path="/uretim" element={<Uretim />} />
            <Route path="/ar-ge" element={<Rand />} />
            <Route path="/sosyal-sorumluluk" element={<SocialResponsibility />} />
            <Route path="/iletisim" element={<Contact />} />


            <Route path="/urunler" element={<Products />} >
              {/* <Route path=":id1"  element={<ProductDetail />}>
                <Route path=":id2"  />
              </Route> */}
            </Route>

            <Route path="/urunler/:id1"  ></Route>
            <Route path="/urunler/:id1/:id2" element={<ProductDetail />} ></Route>


            <Route path="/markalar/:id1/:id2" element={<BrandsDetail />}/>
            

            {/* <Route path="/kesehome"     element={<KeseHome/>}/>
            <Route path="/pioette"      element={<Pioette/>}/>
            <Route path="/cotton-lounge" element={<CottonLounge/>}/> */}

          </Route>
        </Routes>
      </AnimatePresence>
    </div>
    </ReactLenis>
  );
}

export default App;
